
// region JS Imports

// region External Modules
// endregion External Modules

// region Private Modules
import I18n from "plugins/i18n-js"
import dayjs from "plugins/dayjs"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


enum EconomicIndicatorIdentifier {
  HANG_SENG_INDEX                   = "hang_seng_index",
  HK_UNEMPLOYMENT_RATE              = "hk_unemployment_rate",
  HK_MORTGAGE_INTEREST_RATE         = "hk_mortgage_interest_rate",
  HK_GDP                            = "hk_gdp",
  US_DOLLAR_INDEX                   = "us_dollar_index",
  HK_PRIVATE_DOMESTIC_PRICE_INDEX   = "hk_private_domestic_price_index",
  HK_PRIVATE_DOMESTIC_RENTAL_INDEX  = "hk_private_domestic_rental_index",
}

const EconomicIndicatorHighchartDisplay = {
  // economic indicator would have different number display format from default one
  yAxisNumberFormatter( compare_option: string | null, original_value: number) {
    switch (compare_option) {
      case EconomicIndicatorIdentifier.HANG_SENG_INDEX:
        if ( original_value === 0 ) {
          return original_value
        }

        if ( I18n.locale === "zh-TW" || I18n.locale === "zh-HK" ) {
          return `${Math.round(original_value / 1000.0) / 10.0}萬`
        }
        else if ( I18n.locale === "zh-CN" ) {
          return `${Math.round(original_value / 1000.0) / 10.0}万`
        }
        else {
          return `${Math.round(original_value / 1000.0)}K`
        }

      case EconomicIndicatorIdentifier.HK_UNEMPLOYMENT_RATE:
      case EconomicIndicatorIdentifier.HK_GDP:
        return `${parseFloat(original_value.toFixed(1))}%`

      case EconomicIndicatorIdentifier.HK_MORTGAGE_INTEREST_RATE:
        return `${parseFloat(original_value.toFixed(2))}%`

      case EconomicIndicatorIdentifier.US_DOLLAR_INDEX:
      case EconomicIndicatorIdentifier.HK_PRIVATE_DOMESTIC_PRICE_INDEX:
      case EconomicIndicatorIdentifier.HK_PRIVATE_DOMESTIC_RENTAL_INDEX:
        return `${Math.round(original_value).toLocaleString()}`

      default:
        return original_value
    }
  },

  tooltipNumberFormatter( compare_option: string | null, original_value: number | null ) {
    if ( original_value == null ) {
      return "-"
    }

    switch (compare_option) {
      case EconomicIndicatorIdentifier.HK_UNEMPLOYMENT_RATE:
      case EconomicIndicatorIdentifier.HK_MORTGAGE_INTEREST_RATE:
      case EconomicIndicatorIdentifier.HK_GDP:
        return `${original_value.toLocaleString()}%`

      default:
        return original_value.toLocaleString()
    }
  },

  tooltipMonthFormatter(compare_option: string | null, date_value: string | null, spacious_economic_indicator_date_label_format_type: string ) {
    switch (compare_option) {
      case EconomicIndicatorIdentifier.HK_GDP:
        return [
          spacious_economic_indicator_date_label_format_type === "Q YYYY" ? "Q" : "",
          dayjs(date_value).add(0, "month").locale(I18n.locale.toLowerCase()).format(spacious_economic_indicator_date_label_format_type),
        ].join("")

      default:
        return [
          dayjs(date_value).add(0, "month").locale(I18n.locale.toLowerCase()).format(spacious_economic_indicator_date_label_format_type),
        ].join("")
    }
  },

  should_allow_decimals(compare_option: string | null) {
    switch (compare_option) {
      case EconomicIndicatorIdentifier.HK_MORTGAGE_INTEREST_RATE:
      case EconomicIndicatorIdentifier.HK_GDP:
        return true

      default:
        return false
    }
  },
}

export default EconomicIndicatorHighchartDisplay
